import negate from 'lodash/fp/negate';
import { State } from '../state';
import { VideoOverlay } from '../state/VideoOverlay';
import { sortToDescendingPriority } from './manageVideoPlayerOverlays/sorter';
import { VideoOverlayPayload, createVideoOverlayWithVideoOverlayPayload } from './manageVideoPlayerOverlays/createOverlayHelper';

export const add = (state: State, payload: VideoOverlayPayload): void => {
  const overlay = createVideoOverlayWithVideoOverlayPayload(payload);
  state.overlays = [...state.overlays, overlay].sort(sortToDescendingPriority);
};

export const remove = (state: State, payload: VideoOverlayPayload): void => {
  const overlay = createVideoOverlayWithVideoOverlayPayload(payload);
  state.overlays = state.overlays.filter((stateOverlay) => !(
    stateOverlay.name === overlay.name &&
    stateOverlay.type === overlay.type &&
    stateOverlay.priority === overlay.priority
  ));
};

/**
 * If the provided value is evaluated to true, it will be removed from the queue
 */
export type RemoveAllMatchPredicate = (overlay: VideoOverlay) => boolean;

export const removeAll = (state: State, matchPredicate?: RemoveAllMatchPredicate): void => {
  if (matchPredicate) {
    state.overlays = state.overlays.filter(negate(matchPredicate));
    return;
  }

  state.overlays = [];
};
